import { useEffect } from 'react';
import posthog from 'posthog-js';
import { fetchSession } from '@/features/auth/api/auth-api';
import { useAuthStore } from '@/shared/stores/auth-store';
import { clearSessionToken, setSessionToken } from '@/shared/services/session-token';

export function AuthBootstrap() {
  const setSession = useAuthStore((state) => state.setSession);
  const setSessionLoading = useAuthStore((state) => state.setSessionLoading);
  const setSessionHydrated = useAuthStore((state) => state.setSessionHydrated);
  const logout = useAuthStore((state) => state.logout);

  useEffect(() => {
    let cancelled = false;

    async function hydrateSession() {
      // No early-out when there's no local token: fetchSession also authenticates
      // off the shared Events.com session cookie (embedded — see backend
      // getSessionFromCookie). Always attempt it; a 401 means "not signed in".
      setSessionLoading(true);

      try {
        const session = await fetchSession();
        if (cancelled) return;

        setSessionToken(session.token);
        setSession({
          user: session.user,
          permissions: session.permissions,
          orgId: session.selectedOrganizationId,
          organizations: session.organizations,
        });
        if (session.user) {
          posthog.identify(session.user.id, {
            email: session.user.email,
            role: session.user.role,
            orgId: session.selectedOrganizationId,
          });
        }
      } catch {
        if (cancelled) return;
        clearSessionToken();
        logout();
      } finally {
        if (!cancelled) {
          setSessionLoading(false);
          setSessionHydrated(true);
        }
      }
    }

    void hydrateSession();

    return () => {
      cancelled = true;
    };
  }, [logout, setSession, setSessionHydrated, setSessionLoading]);

  return null;
}
